export const CHECK_DOWNLOAD_REQUEST = 'CHECK_DOWNLOAD_REQUEST';
export const CHECK_DOWNLOAD_SUCCESS = 'CHECK_DOWNLOAD_SUCCESS';
export const CHECK_DOWNLOAD_FAILURE = 'CHECK_DOWNLOAD_FAILURE';

export const CHECK_UPLOAD_REQUEST = 'CHECK_UPLOAD_REQUEST';
export const CHECK_UPLOAD_SUCCESS = 'CHECK_UPLOAD_SUCCESS';
export const CHECK_UPLOAD_FAILURE = 'CHECK_UPLOAD_FAILURE';


export const checkDownloadRequest = () => ({
  type: CHECK_DOWNLOAD_REQUEST,
});

export const checkDownloadSuccess = payload => ({
  type: CHECK_DOWNLOAD_SUCCESS,
  payload,
});

export const checkDownloadFailure = payload => ({
  type: CHECK_DOWNLOAD_FAILURE,
  payload,
});

export const checkUploadRequest = () => ({
  type: CHECK_UPLOAD_REQUEST,
});

export const checkUploadSuccess = payload => ({
  type: CHECK_UPLOAD_SUCCESS,
  payload,
});

export const checkUploadFailure = payload => ({
  type: CHECK_UPLOAD_FAILURE,
  payload,
});


const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  report: null,
  downloadSpeed: 'Waiting...',
  uploadSpeed: 0,
};

export function checkInternetReducer(state = initialState, action) {
  switch (action.type) {

    case CHECK_DOWNLOAD_REQUEST:
      return {
        ...state,
        fetching: true,
        isFetched: false,
      };
    case CHECK_DOWNLOAD_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        downloadSpeed: action.payload,
      };
    case CHECK_DOWNLOAD_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
        isFetched: true
      };
    default:
      return state;
  }
}
